import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

import Heading from './Heading'

const Nav = ({
  promotions,
  years,
  nwawcwCollections,
  wwfCollections,
  events,
}) => {
  return (
    <Wrapper>
      <li>
        <Heading>Promotions</Heading>
        <ul>
          {promotions.map((promotion) => (
            <li key={promotion.id}>
              <Link className="mod-underline" to={promotion.gatsbyPath}>
                {promotion.name}
              </Link>
            </li>
          ))}
        </ul>
      </li>
      <li>
        <Heading>Years</Heading>
        <ul>
          {years.map((year) => (
            <li key={year.id}>
              <Link className="mod-underline" to={year.gatsbyPath}>
                {year.name}
              </Link>
            </li>
          ))}
        </ul>
      </li>
      <li>
        <Heading>NWA Collections</Heading>
        <ul>
          {nwawcwCollections.map((collection) => (
            <li key={collection.id}>
              <Link className="mod-underline" to={collection.gatsbyPath}>
                {collection.name}
              </Link>
            </li>
          ))}
        </ul>
      </li>
      <li>
        <Heading>WWF Collections</Heading>
        <ul>
          {wwfCollections.map((collection) => (
            <li key={collection.id}>
              <Link className="mod-underline" to={collection.gatsbyPath}>
                {collection.name}
              </Link>
            </li>
          ))}
        </ul>
      </li>
      <li>
        <Heading>All Events</Heading>
        <ul>
          {events.map((event) => (
            <li key={event.id}>
              <Link
                className="mod-underline"
                to={`/event/${event.slug.current}`}
              >
                {event.name}
              </Link>
            </li>
          ))}
        </ul>
      </li>
    </Wrapper>
  )
}

const Wrapper = styled.ul`
  li {
    font-family: var(--font-display);
    font-size: var(--font-size-6);
    line-height: var(--font-lineheight-6);
    font-weight: var(--font-weight-7);
    text-transform: uppercase;

    @media (min-width: 768px) {
      font-size: var(--font-size-8);
      line-height: var(--font-lineheight-8);
    }
  }

  > li {
    margin: var(--size-6) 0;

    @media (min-width: 768px) {
      margin-bottom: var(--size-8) 0;
    }
  }

  li > ul {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;

    li {
      display: flex;
      justify-content: center;
      align-items: center;
      a {
        color: var(--color-text2);
        white-space: nowrap;
        transition: color 250ms;

        &:hover,
        &:active {
          color: var(--color-secondary);
        }

        &::after {
          background: var(--color-primary);
          bottom: 0.1em;
        }
      }

      &:not(:last-child) {
        &::after {
          content: ' • ';
          margin: 0 0.25em;
          color: var(--color-text2);
        }
      }
    }
  }
`

export default Nav
